import { ValueOf } from 'utils/utiltyTypes/utilityTypes'
import { assessmentSchedule } from '@omnea-app/packages/backend/infraContracts/scheduleDefinitions'
import { EntityAndSchedules } from '@omnea-app/packages/backend/schedulerApiClient/schedulerApiClient'

export { assessmentSchedule }

export type AssessmentScheduleActions = ValueOf<typeof assessmentSchedule.actions>
export type AssessmentEntityAndSchedule = EntityAndSchedules<typeof assessmentSchedule.entity, AssessmentScheduleActions>
